<template>
  <div>
    <div class="d-flex align-items-center mb-1" style="gap: 0.5rem;">
      <b-badge :variant="check.tested ? 'light-success' : 'light-warning'">
        {{ check.tested ? 'Test edilen ayar' : 'Test edilmemiş ayar' }}
      </b-badge>
      <b-badge v-if="check.errors && check.errors.length" variant="light-danger">{{ check.errors.length }} hata</b-badge>
    </div>
    <b-alert :show="!!(check.errors && check.errors.length)" variant="danger" class="mb-1">
      <ul class="p-1 pl-2 mb-0"><li v-for="(e, i) in check.errors" :key="`e${i}`">{{ e }}</li></ul>
    </b-alert>
    <b-alert :show="!!(check.warnings && check.warnings.length)" variant="warning" class="mb-1">
      <ul class="p-1 pl-2 mb-0"><li v-for="(w, i) in check.warnings" :key="`w${i}`">{{ w }}</li></ul>
    </b-alert>
    <div v-if="expected" class="border rounded p-1">
      <div class="mb-50"><strong>Test referansı</strong> <small class="text-muted">(geçmiş garanti değildir)</small></div>
      <b-row class="text-center">
        <b-col cols="4">
          <small class="text-muted">2020-26 ağırlıklı</small>
          <h5 class="mb-0">{{ usd(expected.weightedMonthly) }}/ay</h5>
        </b-col>
        <b-col cols="4">
          <small class="text-muted">Oca-Eyl 2026</small>
          <h5 class="mb-0">{{ usd(expected.jan2026SepMonthly) }}/ay</h5>
        </b-col>
        <b-col cols="4">
          <small class="text-muted">Maks DD</small>
          <h5 class="mb-0">{{ expected.maxDdPct == null ? '—' : `${expected.maxDdPct}%` }}</h5>
        </b-col>
      </b-row>
    </div>
    <small v-else class="text-muted">Bu ayar için test referansı yok (yalnız test edilen ayarda ve Sabit modda gösterilir).</small>
  </div>
</template>

<script>
import {
  BBadge, BAlert, BRow, BCol,
} from 'bootstrap-vue'
import { formatUsd } from '../fleetFormat'

export default {
  name: 'FleetCheckPanel',
  components: {
    BBadge, BAlert, BRow, BCol,
  },
  props: {
    check: { type: Object, default: () => ({ errors: [], warnings: [], tested: false }) },
    expected: { type: Object, default: null },
  },
  methods: { usd: v => formatUsd(v) },
}
</script>
